import api from './api.service';

/**
 * Recherche d'adresse — passe par NOTRE API, jamais par Google directement.
 * La clé Places reste côté serveur (cf. app/infrastructure/places_client.py) :
 * la poser dans le bundle du back-office l'exposerait à qui le télécharge.
 */
export interface AddressSuggestion {
  placeId: string;
  description: string;
}

export interface AddressDetails {
  address: string;
  zipCode: string;
  city: string;
  countryCode: string;
  latitude: number | null;
  longitude: number | null;
  formattedAddress: string;
}

/**
 * Un jeton de session regroupe les frappes ET la sélection finale en une seule
 * session facturée par Google, au lieu d'une requête facturée par caractère.
 * À renouveler après chaque sélection.
 */
export function newSessionToken(): string {
  return (
    globalThis.crypto?.randomUUID?.() ??
    `s-${Date.now()}-${Math.random().toString(36).slice(2)}`
  );
}

export const placesService = {
  async autocomplete(q: string, sessionToken: string): Promise<AddressSuggestion[]> {
    const res = await api.get('/places/autocomplete', { params: { q, sessionToken } });
    return res.data.suggestions ?? [];
  },

  async details(placeId: string, sessionToken: string): Promise<AddressDetails> {
    const res = await api.get('/places/details', { params: { placeId, sessionToken } });
    return res.data;
  },
};
